module.exports = __webpack_public_path__ + "img/set.386e9c4c.png";